export default {
	messages: {
		will_be_deleted: " will be deleted",
		will_be_archived: "will be archived",
		will_be_Unarchived: "will be unarchiv",
	},
	buttons: {
		new_user: "New user",
		export_csv: "Export CSV",
		upload: "Upload",
		change_password: "Change password",
		close: "Close",

		new_employee: "New employee",
		back_to_employee: "Back to employees",
		edit_employee: "Edit employee",
		edit_resume: "Edit resume",
		delete_employee: "Delete employee",
		delete_resume: "Delete resume",
		archive_employee: "Archive employee",
		archive_resume: "Archive resume",
		unarchive_employee: "Unarchive employee",
		unarchive_resume: "Unarchive resume",
		save_employee: "Save employee",

		new_client: "New client",
		back_to_client: "Back to clients",
		edit_client: "Edit client",
		delete_client: "Delete client",
		save_client: "Save client",

		new_resume: "New resume",
		back_to_resume: "Back to resumes",
		edit_resume: "Edit resume",
		delete_resume: "Delete resume",
		save_resume: "Save resume",
		view_resumes: "View resumes",

		new_area: "New area",
		back_to_area: "Back to areas",
		edit_area: "Edit area",
		delete_area: "Delete area",
		save_area: "Save area",

		new_language: "New language",
		back_to_language: "Back to languages",
		edit_language: "Edit language",
		delete_language: "Delete language",
		save_language: "Save language",

		new_skill: "New skill",
		back_to_skill: "Back to skills",
		back_to_areas: "Back to areas",
		delete_skill: "Delete skill",
		edit_skill: "Edit skill",
		save_skill: "Save skill",

		add_education: "Add education",
		remove_education: "Remove education",

		add_experience: "Add experience",
		remove_experience: "Remove experience",

		add_course: "Add course",
		remove_course: "Remove course",

		add_link: "Add link",
		remove_link: "Remove link",

		add_ability: "Add ability",
		remove_ability: "Remove ability",

		add_language: "Add language",
		remove_language: "Remove language",

		download_resume: "Download Resume (PDF)",
		download_word: "Download as Word",
	},
	navigations: {
		dashboard: "Dashboard",
		clients: "Clients",
		client_resumes: "Client Resumes",
		employee_resumes: "Contracts Resumes",
		client_resume_edit: "Edit Client Employee Resume",
		audits: "Audits",
		log_out: "Log out",
		previous: "Previous",
		next: "Next",
		create_client: "Create client",
		create_client_resume: "Create client resume",
		create_employee_resume: "Create employee resume",
		edit_client: "Edit client",

		employee: "Contracts",
		resume: "Atis Resumes",
		skill: "Skills",
		area: "Areas",
		language: "Languages",
		archive: "Archived Resumes",
	},
	labels: {
		profile_settings: "Profile settings",
		create_user: "Create user",
		edit_user: "Edit user",
		edit_password: "Edit password",
		roles: "Roles",
		show_deleted: "Show deleted",
		delete: "Delete",
		archive: "Archive",
		unarchive: "Unarchive",
		close: "Close",
		educations: "Educations",
		experiences: "Experiences",
		courses: "Courses",
		links: "Links",
		abilities: "Skills",
		education: "Education",
		experience: "Experience",
		course: "Course",
		link: "Link",
		ability: "Skill",
		language: "Language",
		languages: "Languages",
		employee_data: "Employee Data",
	},
	app: {
		loading: "Loading...",
	},
};
